import { View, VStack } from "@gluestack-ui/themed";
import { LimitsVerifyIdentityController } from "./controller";
import { Button } from "@repo/core/components/core/Button";
import { IdentityTypeInput } from "@repo/core/components/forms/IdentityTypeInput";
import Scaffolds from "@repo/core/components/layout/Scaffolds";
import { StatusBarVariantEnum } from "@repo/core/components/layout/StatusBar/types";

const LimitsVerifyIdentity = () => {
  const {
    isMobile,
    back,
    control,
    handleOnChangeIdentityType,
    selectedIdentityInputType,
    handleOnSelectProduct,
    handleOnSubmitForm,
    isSubmitting,
    isButtonDisabled
  } = LimitsVerifyIdentityController();
  return (
    <Scaffolds.Root
      showHeader={false}
      statusBarVariant={StatusBarVariantEnum.STORE_SELECT}
    >
      <Scaffolds.StoreSelect
        title="Consulta Limites Disponíveis"
        showConfirmStoreModal
      >
        <Scaffolds.Form
          showHeader={false}
          p="$4"
          footerContent={
            <View
              w="$full"
              gap="$4"
              flexDirection={!isMobile ? "row-reverse" : "column"}
              pt={isMobile ? "$0" : "$12"}
              justifyContent="flex-end"
            >
              <Button
                flex={isMobile ? undefined : 1}
                size="xl"
                action="primary"
                text="Simular"
                onPress={handleOnSubmitForm}
                isLoading={isSubmitting}
                isDisabled={isButtonDisabled}
              />
              <Button
                flex={isMobile ? undefined : 1}
                action="negative"
                variant="outline"
                size="xl"
                text="Cancelar"
                onPress={back}
              />
            </View>
          }
        >
          <VStack flex={1}>
            <IdentityTypeInput
              onChangeInputType={handleOnChangeIdentityType}
              control={control}
              selectedInputType={selectedIdentityInputType}
              onSelectProduct={handleOnSelectProduct}
              showCardExpiryInput={false}
              shouldFetchOnCardSubmit={false}
            />
          </VStack>
        </Scaffolds.Form>
      </Scaffolds.StoreSelect>
    </Scaffolds.Root>
  );
};
export default LimitsVerifyIdentity;
